import { render, staticRenderFns } from "./TasinmazBilgileriList.vue?vue&type=template&id=0624ecfe"
import script from "./TasinmazBilgileriList.vue?vue&type=script&lang=ts"
export * from "./TasinmazBilgileriList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports